<template>
    <div>
        <v-dialog :modelValue="dialog_view" max-width="750" @click:outside="close" @keydown.esc="close">
            <v-card>
                <v-card-title class="headline">
                    {{ title }}
                </v-card-title>

                <v-card-text>
                    <div class="row">
                        <div class="col-md-12">
                            <v-data-table :headers="headers" :items="remitos" :search="search" loading-text="Cargando...">
                                <template v-slot:item="props">
                                    <tr>
                                        <td>{{ props.item.number }}</td>
                                        <td>{{ props.item.user != null ? props.item.user.name : "-" }}</td>
                                        <td>{{ props.item.creation_date }}</td>
                                    </tr>
                                </template>
                                <template v-slot:no-data>
                                    <v-alert :value="true" color="info" icon="info">
                                        {{ "El ASN no tiene remitos/facturas cargados" }}
                                    </v-alert>
                                </template>
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ "Busqueda sin resultados - " + search }}
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="red darken-1" text @click="close()"> Cerrar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    mixins: [],
    props: {
        title: String,
        dialog_view: Boolean,
        remitos: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        search: "",
        headers: [
            { title: "Numero", align: "left", sortable: true, key: "number" },
            { title: "Usuario", align: "left", sortable: true, key: "user.name" },
            { title: "Fecha", align: "left", sortable: true, key: "creation_date" },
        ],
    }),
    created: function () {
        window.addEventListener("keydown", (e) => {
            if (e.key == "Escape") {
                this.close();
            }
        });
    },
    methods: {
        close() {
            this.$emit("closeDialog");
        },
    },
};
</script>
